import _              from 'lodash'
import React          from 'react'
import { withRouter } from 'react-router'
import { Link       } from 'react-router-dom'
import { Alert      } from 'react-bootstrap'

import { DateTimePicker, HorizontalForm        } from 'alto-react-components/lib/components'
import { Registration                          } from 'alto-react-base-auth/lib/components'
import { billVerificationSetting               } from 'alto-react-client-auth/lib/settings'
import { cardNumberForm, registrationWithoutBV } from 'alto-react-client-auth/lib/routes'

class InfoAlert extends React.Component
  render: ->
    <Alert bsStyle="info" id="bill-verification-info">
      {@commonMessage()}
      {@withoutBvMessage()}
    </Alert>

  commonMessage: ->
    <p>
      {@reasonMessage()} je třeba projít <strong>registrací s ověřením účtenky</strong>.
      Níže zadejte číslo a datum vystavení jakékoli účtenky, kterou jste v některé
      z našich {@props.settings.pluralGenetiveBusinessName} obdrželi.
    </p>

  withoutBvMessage: ->
    if @props.reasonCode == 'choose_different_email'
      linkLocation =
        pathname: registrationWithoutBV,
        state: { email: @props.email, card_number: @props.cardNumber }

      link = <Link to={linkLocation} id='non-bv-link'>registraci bez ověření účtenky</Link>

      <p>
        Pokud se chcete registrovat s emailem <strong>{@props.email}</strong>,
        můžete použít <strong>{link}</strong>.
      </p>

  reasonMessage: ->
    if @props.settings.showReason
      messages =
        no_valid_email:         'u Vašeho účtu není vyplněna platná emailová adresa'
        choose_different_email: 'jste se chtěli registrovat s jiným emailem, než u Vás evidujeme'
        several_clients_found:  'bylo nalezeno několik klientů s daným číslem karty'

      "Protože #{messages[@props.reasonCode]},"
    else
      'Pro ověření Vaší totožnosti'

class LoginCredentialsFormWithBV extends Registration.WrappedComponent
  constructor: (props, context) ->
    super(props, context)

    @state.billNumber       = ''
    @state.billDate         = null
    @state.billVerification = billVerificationSetting(context.settings)

    state = props.location.state

    if state and state.card_number and state.reason
      @cardNumber = state.card_number
      @reasonCode = state.reason
      @email      = state.email
    else
      # missing state, redirect back to card number form
      props.history.replace(cardNumberForm)

  info: ->
    <InfoAlert email={@email} cardNumber={@cardNumber} reasonCode={@reasonCode}
               settings={@state.billVerification} />

  additionalInputs: ->
    <div>
      {@billNumberInput()}
      {@billDateInput()}
    </div>

  billNumberInput: ->
    errors = @errorsFor('billNumber')

    <HorizontalForm.Control id='bill-number' type='text' label='Číslo účtenky'
     placeholder='Zadejte číslo účtenky'
     value={@state.billNumber}
     valid={@state.billNumber.length and !errors?}
     help={errors}
     onChange={(value) => @setState(billNumber: value)}
     onKeyPress={(e)   => @submit() if e.key == 'Enter'} />

  billDateInput: ->
    errors = @errorsFor('billDate')

    <HorizontalForm.Group id='bill-date' label='Datum vystavení účtenky'
                          valid={@state.billDate and !errors?} help={errors}>
      <DateTimePicker
       time={false}
       openOnFocus={true}
       value={@state.billDate}
       placeholder='Zadejte datum vystavení účtenky'
       onChange={(value) => @setState(billDate: value)}
       onKeyPress={(e)   => @submit() if e.key == 'Enter'} />
    </HorizontalForm.Group>

  isValid: ->
    super() and @state.billNumber.length and @state.billDate

  register: (credentials) ->
    @context.auth.registerClientWithBV(
      @cardNumber, _.assign({}, credentials, _.pick(@state, 'billNumber', 'billDate')))

export default withRouter(LoginCredentialsFormWithBV)
